import { apiClient } from '@/shared/lib/apiClient';
import type {
  SubscriptionEventAnalytics,
  SubscriptionEventHistoryItem,
  SubscriptionEventHistoryQuery,
} from '../types';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function fetchSubscriptionEventHistory(
  query: SubscriptionEventHistoryQuery,
  signal?: AbortSignal,
): Promise<SubscriptionEventHistoryItem[]> {
  const params: Record<string, string> = {};
  if (query.tenantId) params.tenantId = query.tenantId;
  if (query.subscriptionId) params.subscriptionId = query.subscriptionId;
  if (query.productId) params.productId = query.productId;
  if (query.eventType) params.eventType = query.eventType;
  if (query.eventSource) params.eventSource = query.eventSource;
  if (query.limit !== undefined) params.limit = String(query.limit);

  const res = await apiClient.get<ApiResponse<SubscriptionEventHistoryItem[]>>(
    '/api/v1/subscription-events/history',
    {
      params,
      ...(signal ? { signal } : {}),
    },
  );
  return res.data;
}

export async function fetchSubscriptionEventAnalytics(
  signal?: AbortSignal,
): Promise<SubscriptionEventAnalytics> {
  const res = await apiClient.get<ApiResponse<SubscriptionEventAnalytics>>(
    '/api/v1/subscription-events/analytics',
    signal ? { signal } : undefined,
  );
  return res.data;
}
